import { watch, ref } from '@vue/composition-api';
import stateProviderSetup from 'mixins/composition/search/StateProvider';

export default ({
  app, store, refs,
}) => {
  const { showModalStatus, fullscreenmap } = stateProviderSetup({ app, store });
  const searchModalInitialized = ref(false);
  const searchModalReady = ref(false);

  return {
    searchModalInitialized,
    searchModalReady,
    watchForModalChanges: () => {
      watch(showModalStatus, (value) => {
        if (value) {
          if (!searchModalInitialized.value) {
            searchModalInitialized.value = true;
            return;
          }
          if (refs.searchModal) {
            refs.searchModal.show();
            document.querySelector('html').classList.add('scroll-off');
          }
        } else if (refs.searchModal) {
          // set client search to true, because modals hide all objects and we want them to lazy load after re-render
          store.commit('SET_SEARCH_CLIENTSEARCH', true);
          document.querySelector('html').classList.remove('scroll-off');
          refs.searchModal.close();
        }
      });

      watch(searchModalReady, (value) => {
        if (value) {
          app.$nextTick(() => {
            if (refs.searchModal) {
              refs.searchModal.show();
              document.querySelector('html').classList.add('scroll-off');
            }
          });
        }
      });

      watch(fullscreenmap, (value) => {
        if (value) {
          app.$modal.show('mapModal');
          document.querySelector('html').classList.add('scroll-off');
        } else if (refs.searchMapModal) {
          // set client search to true, because modals hide all objects and we want them to lazy load after re-render
          store.commit('SET_SEARCH_CLIENTSEARCH', true);
          const parentElements = document.querySelectorAll('.scroll-off');
          app.$modal.hide('mapModal');
          if (parentElements) {
            parentElements.forEach((el) => {
              el.classList.remove('scroll-off');
            });
          }
        }
      });
    },
  };
};
